import script from "./MiniWizardBase.vue?vue&type=script&lang=js"
export * from "./MiniWizardBase.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__